export default __webpack_public_path__ + "static/media/chat.8c07229f.svg";